import React from "react";
import "../styles/Preloader.css"; // Стили для загрузки

const Preloader = ({ isLoading }) => {
    return (
        <div className={`preloader-overlay ${isLoading ? "visible" : "hidden"}`}>
            <div className="loader"></div>
            <img src="/assets/logologo.webp" alt="prelogo" className="prelogo" />

        </div>
    );
};

export default Preloader;
